// extracted by mini-css-extract-plugin
export default {"inductionsContainer":"inductions_inductionsContainer__UuI2N","titleHead":"inductions_titleHead__ymqY9","image":"inductions_image__oKRA1"};